var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpressjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483 1769 c-166 -28 -320 -145 -398 -302 -49 -100 -89 -286 -82 -387 18 -271 123 -460 301 -544 95 -45 163 -60 271 -60 244 1 433 139 499 363 22 76 21 81 -17 81 -42 0 -57 -17 -86 -95 -42 -117 -133 -206 -244 -241 -29 -9 -93 -18 -143 -21 -101 -6 -176 10 -250 53 -63 37 -141 126 -175 199 -30 64 -58 186 -59 258 l0 37 506 0 506 0 -7 93 c-3 50 -13 121 -22 157 -50 208 -206 362 -408 405 -77 16 -114 17 -192 4z m190 -94 c84 -22 134 -50 194 -111 81 -81 143 -231 143 -346 l0 -28 -450 0 -450 0 0 38 c0 51 25 146 56 209 89 184 313 289 507 238z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213 1743 c-19 -4 2 -35 176 -261 108 -141 209 -273 224 -293 l27 -35 -240 -323 c-132 -177 -240 -324 -240 -328 0 -3 23 -3 50 -1 35 4 59 13 76 29 14 13 111 140 216 281 104 142 193 260 197 263 5 2 92 -112 195 -253 102 -142 199 -271 215 -286 23 -22 43 -30 81 -34 32 -3 50 -1 50 6 0 6 -103 149 -230 316 -153 203 -230 314 -230 330 0 15 38 73 103 158 218 282 319 420 313 426 -14 13 -77 5 -103 -14 -16 -11 -107 -124 -203 -251 -96 -128 -178 -235 -182 -238 -4 -4 -87 101 -185 233 -98 132 -189 247 -203 255 -30 17 -76 26 -107 20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressjs);
export default __webpack_public_path__ + "static/media/expressjs.651a1837c84377397e8f4197d2e07482.svg";
export { ForwardRef as ReactComponent };